/*
	Template set builder for the Diagram and RichText editor input types.

	Both editors render the same wrapper — a labeled column whose body (the toggle + editor/view slot)
	is chosen per field at render time by the `{~EditorBody:<Theme>~}` macro; see EditorBodies.js for the
	markup and HeadlightDynamicInputsBundle.js for the macro that fills it in.

	STANDARD and VERTICAL only. These types have no Tabular entries on purpose: the pict-section-form
	provider throws inside a tabular row (N Excalidraw/CodeMirror instances per row is a performance
	landmine), so there is nothing to render there. RecordSet reuses the Tabular templates, so it is
	unsupported for the same reason — Standard and Vertical are the supported layouts.
*/

/** The single-record wrapper. The body macro fills in the presentation for this theme. */
const _buildStandardTemplate = (pInputType, pTheme) => /*HTML*/`
		<!-- InputType ${pInputType} {~D:Record.Hash~} {~D:Record.DataType~} -->
		<div class="column {~ColumnWidth:Record~}${pTheme === 'Print' ? ' {~HideInPDF:Record~}' : ''}">
			<label class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
			{~EditorBody:${pTheme}~}
		</div>`;

/** The label-left vertical wrapper, matching the HTML/Markdown vertical layout. */
const _buildVerticalTemplate = (pInputType, pTheme) => /*HTML*/`
		<!-- InputType ${pInputType} {~D:Record.Hash~} {~D:Record.DataType~} -->
		<div class="pict-form-vertical-input column ${pTheme === 'Print' ? 'pb-1 {~HideInPDF:Record~}' : 'pb-3'}">
			<div class="columns is-mobile is-vcentered">
				<div class="column">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				</div>
				<div class="column description-text">{~D:Record.Description~}</div>
				<div class="column">
					{~EditorBody:${pTheme}~}
				</div>
			</div>
		</div>`;

/**
 * Build the Edit/Read/Print template entries for an editor input type.
 * @param {string} pInputType - 'Diagram' or 'RichText'.
 * @return {{ Edit: Array<object>, Read: Array<object>, Print: Array<object> }}
 */
function buildEditorTemplates(pInputType)
{
	const tmpThemeEntries = (pTheme) => (
		[
			{
				HashPostfix: `-Template-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ `Pict-Input-${pInputType}` ],
				Template: _buildStandardTemplate(pInputType, pTheme),
			},
			{
				HashPostfix: `-VerticalTemplate-Input-InputType-${pInputType}`,
				DefaultInputExtensions: [ `Pict-Input-${pInputType}` ],
				Template: _buildVerticalTemplate(pInputType, pTheme),
			},
		]);
	return {
		Edit: tmpThemeEntries('Edit'),
		Read: tmpThemeEntries('Read'),
		Print: tmpThemeEntries('Print'),
	};
}

module.exports = { buildEditorTemplates };
